import { TenantEntity } from '../TenantEntity'

export class AutomationConfig extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get taskName() {
    return this._data.taskName
  }
  set taskName(taskName) {
    this._data.taskName = taskName
  }
  get taskScenario() {
    return this._data.taskScenario
  }
  set taskScenario(taskScenario) {
    this._data.taskScenario = taskScenario
  }
  get dataType() {
    return this._data.dataType
  }
  set dataType(dataType) {
    this._data.dataType = dataType
  }
  get executionStatus() {
    return this._data.executionStatus
  }
  set executionStatus(executionStatus) {
    this._data.executionStatus = executionStatus || 0
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
}
